import React from 'react';

class Wrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        const p = this.props;
        return(
            <div className = "marketkit-numeric-picker-wrapper">
                { p.children }
            </div>
        )
    }
}

export default Wrapper;